import { Component } from "react";
import "./LocationInput.css";
import PlacesAutocomplete from "react-places-autocomplete";
import { LocationType } from "services/util";
import { logError } from "services/logging";

export const LocationInput = props => {
  const getSuggestedItem = (getSuggestionItemProps, suggestion) => {
    if (
      props.locationType === LocationType.ADDRESS ||
      suggestion.types.includes("locality") ||
      suggestion.types.includes("administrative_area_level_3")
    ) {
      const className = suggestion.active ? "suggestion-item--active" : "suggestion-item";
      return (
        <div {...getSuggestionItemProps(suggestion, { className })}>
          {suggestion.description}
        </div>
      );
    }
  };

  const renderFunc = ({ getInputProps, getSuggestionItemProps, suggestions }) => (
    <div className="autocomplete">
      <input {...getInputProps({ className: props.className })} />
      <div className="autocomplete-dropdown-container">
        {suggestions.map(suggestion =>
          getSuggestedItem(getSuggestionItemProps, suggestion)
        )}
      </div>
    </div>
  );

  return (
    <LocationErrorBoundary>
      <PlacesAutocomplete
        value={props.value}
        onChange={props.handleLocationInput}
        onSelect={props.handleLocationSelect}
        searchOptions={{
          types: [props.locationType ? props.locationType : LocationType.CITIES],
        }}
        highlightFirstSuggestion={true}
      >
        {renderFunc}
      </PlacesAutocomplete>
    </LocationErrorBoundary>
  );
};

class LocationErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    this.setState({ hasError: true });
    logError("Error in LocationInput", error);
  }

  render() {
    if (this.state.hasError) {
      return <span>Unfortunately, location is unavailable right now.</span>;
    }

    return this.props.children;
  }
}
